import TGButton from "src/components/ui/TGButton";
import { TestContext } from "../../store/testContext";
import { FC, useContext, useEffect, useState } from "react";
import { Modal } from "src/components/DialogComponent";
import { addItemRequest, getItemsRequest } from "src/modules/spItems/api";
import { answersRegistry, questionsRegistry, testRegistry } from "src/api/config/notifications.config";
import { collectionsListName } from "src/api/config";
import { Combobox } from "@headlessui/react";
import { CheckIcon, ChevronDownIcon } from "@heroicons/react/24/outline";

interface IProps {
  closeTests?: () => void;
  addTestOnRegistry?: boolean;
  shouldUpdateTestList?: () => void;
}

export const AddTestInRegistry: FC<IProps> = ({ closeTests, addTestOnRegistry, shouldUpdateTestList }) => {
  const {
    state: { IsQuestionFormOpen, Questions, MinCorrectAnswersCount }
  } = useContext(TestContext);

  const [selectedCollection, setSelectedCollection] = useState<any>({});
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [collections, setCollections] = useState<any>([]);
  const [testName, setTestName] = useState("");
  const [loadProgress, setLoadProgress] = useState(false);

  const questionsID: any = [];
  let answers = [];

  const showModal = () => {
    setIsModalOpen(prev => !prev);
    setTestName("");
    setSelectedCollection({});
  };

  const handleSaveTest = async () => {
    setLoadProgress(true);
    try {
      for (const question of Questions) {
        for (const answer of question.Answers) {
          const registryAnswersID = await addItemRequest({
            listName: answersRegistry,
            body: { ...answer, Title: answer.Description },
            updateReducer: false
          });
          answers.push(registryAnswersID);
        }

        const registryQuestionsID = await addItemRequest({
          listName: questionsRegistry,
          body: { Title: question.Description, Answers: answers, TypeQuestion: question.Type, Description: question.Description, ID: question.ID },
          updateReducer: false
        });
        questionsID.push(registryQuestionsID);
        answers.length = 0;
      }

      await addItemRequest({
        listName: testRegistry,
        body: { QuestionsID: questionsID, Title: testName, Collections: selectedCollection.ID, MinCorrectAnswerCount: MinCorrectAnswersCount },
        updateReducer: false
      });

      showModal();
      if (closeTests && addTestOnRegistry) {
        closeTests();
        if (shouldUpdateTestList) {
          shouldUpdateTestList();
        }
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoadProgress(false);
    }
  };

  useEffect(() => {
    getItemsRequest({ listName: collectionsListName }).then(results => setCollections(results?.items));
  }, []);

  const handleChangeCollection = (collection: any) => {
    setSelectedCollection(collection);
  };

  return (
    <div>
      <Modal zIndex={70} open={isModalOpen} toggleDialog={showModal} modalClassName="min-h-px">
        <header className="px-10 pb-4">
          <h2>Сохранение теста</h2>
        </header>

        <div className="px-10 pb-8 border-b">
          <div className="mb-5">
            <div className="flex justify-between">
              <h4 className="mb-[10px] text-black">Коллекция</h4>
              <span className="text-red text-base font-bold">*</span>
            </div>

            <Combobox as="div" value={selectedCollection} onChange={collection => handleChangeCollection(collection)}>
              <div className="relative mt-2">
                <Combobox.Button className="w-full flex justify-between items-center rounded-md border-0 bg-white py-1.5 pl-3 pr-4 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6">
                  {selectedCollection.Title || "Выберите коллекцию"}
                  <ChevronDownIcon width="15" height="15" />
                </Combobox.Button>
                {collections.length > 0 && (
                  <Combobox.Options className="absolute z-10 mt-1 max-h-56 w-full overflow-auto rounded-md bg-white py-1 text-base shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm">
                    {collections.map((collection: any) => (
                      <Combobox.Option key={collection.ID} value={collection} className="group relative cursor-default select-none py-2 pl-3 pr-9 text-gray-900 hover:bg-[#F3F4F6] hover:bg-opacity-50">
                        <div className="flex">
                          <span className="ml-3 truncate font-normal group-focus:font-semibold">{collection.Title}</span>
                        </div>

                        {collection.Title === selectedCollection?.Title ? (
                          <span className="absolute inset-y-0 right-0 flex items-center pr-4 text-indigo-600 group-focus:text-white">
                            <CheckIcon className="h-5 w-5" aria-hidden="true" />
                          </span>
                        ) : null}
                      </Combobox.Option>
                    ))}
                  </Combobox.Options>
                )}
              </div>
            </Combobox>
          </div>

          <div className="w-full">
            <label htmlFor="testName" className="flex justify-between text-sm font-medium leading-6 text-gray-900">
              <h4 className="mb-[10px] text-black">Название теста</h4>
              <span className="text-red text-base font-bold">*</span>
            </label>
            <div className="mt-2">
              <input
                value={testName}
                onChange={e => setTestName(e.target.value)}
                id="testName"
                name="testName"
                type="text"
                placeholder="Введите название теста"
                className="block w-full h-10 rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
              />
            </div>
          </div>
        </div>

        <footer className="pt-10 px-10 flex justify-between ">
          <TGButton color="white" onClick={showModal}>
            Отмена
          </TGButton>
          <div className="flex justify-between gap-[10px]">
            <TGButton color="bluedark" onClick={handleSaveTest} disabled={!testName.length || !selectedCollection.ID || loadProgress}>
              Сохранить
            </TGButton>
          </div>
        </footer>
      </Modal>

      <div>
        {!Questions.length ? null : (
          <TGButton disabled={IsQuestionFormOpen} onClick={showModal}>
            <div className="flex gap-[10px]">
              <svg width="18" height="20" viewBox="0 0 18 20" fill="none" xmlns="http://www.w3.org/2000/svg" className={IsQuestionFormOpen ? "text-[#8899A8]" : "text-[#012169]"}>
                <path
                  d="M17.3125 3.59375L14.2813 0.8125L14.2188 0.78125C14 0.625 13.75 0.53125 13.5313 0.53125H2.71875C1.40625 0.53125 0.34375 1.59375 0.34375 2.90625V17.0312C0.34375 18.3438 1.40625 19.4062 2.71875 19.4062H15.2813C16.5938 19.4062 17.6563 18.3438 17.6563 17.0312V4.40625C17.6563 4.125 17.5625 3.84375 17.3125 3.59375ZM11.4688 1.96875V3.75H4.9375V1.96875H11.4688ZM5.71875 18.0625V12.2812H12.2813V18.0312H5.71875V18.0625ZM16.25 17.0625C16.25 17.5938 15.8125 18.0312 15.2813 18.0312H13.6875V12C13.6875 11.4062 13.1875 10.9062 12.5938 10.9062H5.40625C4.8125 10.9062 4.3125 11.4062 4.3125 12V18.0625H2.71875C2.1875 18.0625 1.75 17.625 1.75 17.0938V2.9375C1.75 2.40625 2.1875 1.96875 2.71875 1.96875H3.53125V4.0625C3.53125 4.65625 4.03125 5.15625 4.625 5.15625H11.7813C12.375 5.15625 12.875 4.65625 12.875 4.0625V1.96875H13.4375L16.25 4.5625V17.0625Z"
                  fill="currentColor"
                />
              </svg>
              Сохранить тест в реестр
            </div>
          </TGButton>
        )}
      </div>
    </div>
  );
};
